angular.module('cfn').factory('analyseService', [
  '$log',
  '$http',
  '$q',
  '$dialog',
  function($log, $http, $q, $dialog) {
    // Public
    return {
      /**
       * GET Years
       * @returns Promise
       */
      loadYears: function(plusThree) {
        var deferred = $q.defer();
        $http
          .get('/365FarmNet/rest/booking/harvestyears?section=FIELD')
          .then(function(response) {
            var years = response.data;

            var yearMap = {},
              inc,
              currentYear = new Date().getFullYear();

            years.forEach(function(y) {
              yearMap[y] = true;
              if (plusThree) {
                // For each year we have bookings in, include the next three years as well. This makes
                // sense for e.g. subsequent nutrient deliveries
                for (inc = 0; inc < 3; inc++) {
                  yearMap[y + inc] = true;
                }
              }
            });
            yearMap[currentYear] = true;
            yearMap[currentYear + 1] = true;

            var resultYears = [];
            $.each(yearMap, function(year) {
              resultYears.push(parseInt(year));
            });

            deferred.resolve(resultYears.sort());
          });

        return deferred.promise;
      },

      selectedYear: function() {
        return new Date().getFullYear();
      }
    };
  }
]);
